import * as tslib_1 from "tslib";
// CR28M https://zpl.io/VYpzkym
import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { Url } from '@wix/da-url';
import LoadingIndicator from '../../../LoadingIndicator';
import Button from '../../../Button';
import Flex from '../../../Flex';
import { ThemeOverride } from '../../../Context';
import { ThemeOptions } from '../../../publicSession/types';
import { IconSize } from '../../../Icons/IconWrap';
import CloseBig from '../../../Icons/CloseBig';
import BellIcon from '../../../Icons/Bell';
import BiButton from '../../../biLogger/Components/BiButton';
import style from '../SiteHeaderMobile.scss';
import { withTranslation } from 'react-i18next';
import s from './NotificationsDropdownMobile.scss';
import { BiEventType } from '../../../biLogger';
var NotificationsDropdownMobileCR28M = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsDropdownMobileCR28M, _super);
    function NotificationsDropdownMobileCR28M() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iframeRef = React.createRef();
        _this.state = {
            isLoading: true,
            // flag used to ensure frame URL gets navigated to only once
            hasBeenOpened: false,
        };
        _this.handleOnLoad = function () {
            // note: this will fire if src is not yet set (or even when the src attribute is missing entirely)
            // so we wait until it's loading our src document to stop showing the loading indicator
            (_this.props.isOpen || _this.state.hasBeenOpened) &&
                _this.setState({ isLoading: false });
        };
        return _this;
    }
    NotificationsDropdownMobileCR28M.prototype.render = function () {
        var _a = this.props, feedbackCount = _a.feedbackCount, isOpen = _a.isOpen, onClick = _a.onClick, biData = _a.biData, onClose = _a.onClose;
        var _b = this.state, isLoading = _b.isLoading, hasBeenOpened = _b.hasBeenOpened;
        var notificationsUrl = Url.feedbackLink();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: style['notifications-icon-container'] },
                React.createElement(BiButton, { biData: biData, className: classnames(style['icon-button'], style['icon-button-has-submenu'], style['bell-button'], isOpen && style['active']), onClick: onClick },
                    React.createElement(BellIcon, { className: style['notifications-icon'], disableDefaultColors: true, size: IconSize.MEDIUM }),
                    feedbackCount !== '0' && (React.createElement("span", { className: style['number-label__red'] },
                        React.createElement("span", { className: style['number'] }, feedbackCount))))),
            React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT, className: classnames(s['container'], isOpen && s['active']) },
                React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", className: s['title-container'] },
                    React.createElement("span", { className: s['title'] }, this.props.t('siteHeader.notificationsMenu.titleMobile')),
                    React.createElement("div", { onClick: function (e) {
                            e.stopPropagation();
                            onClose && onClose();
                        } },
                        React.createElement(CloseBig, { size: IconSize.MEDIUM, disableDefaultColors: true, className: s['close'] }))),
                React.createElement("div", { className: s['separator'] }),
                React.createElement(Flex, { direction: "column", className: s['notifications-frame-wrapper'] },
                    React.createElement("iframe", tslib_1.__assign({ title: "Eclipse notifications", id: "eclipse-notifications-iframe", className: s['notifications-frame'] }, ((isOpen || hasBeenOpened) && {
                        src: Url.notificationsHeaderLink(),
                    }), { ref: this.iframeRef, frameBorder: "0", scrolling: this.state.isLoading ? 'no' : 'yes', onLoad: this.handleOnLoad }))),
                isLoading && (React.createElement(LoadingIndicator, { view: "spinner", className: s['loader'] })),
                React.createElement(Button, { href: notificationsUrl, className: s['footer-see-all'], target: "_top", view: "b81", biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        menu_name: 'notifications',
                        menu_item: 'see_all',
                    } }, this.props.t('siteHeader.notificationsMenu.seeAll')))));
    };
    NotificationsDropdownMobileCR28M.prototype.componentDidUpdate = function (prevProps) {
        // this persists a state saying that the dropdown has been opened and the iframe does
        // (and should continue to have) a `src` attached to it
        if (!this.state.hasBeenOpened) {
            if (!prevProps.isOpen && this.props.isOpen) {
                this.setState({ hasBeenOpened: true });
            }
            if (typeof window !== 'undefined') {
                var height = get(window, 'innerHeight', 0) -
                    parseInt(s['site-header-height-mobile']) -
                    parseInt(s['footer-see-all-height']) -
                    parseInt(s['title-container-height']);
                this.iframeRef.current.style.height = height + "px";
            }
        }
    };
    return NotificationsDropdownMobileCR28M;
}(React.Component));
export { NotificationsDropdownMobileCR28M };
export default withTranslation()(NotificationsDropdownMobileCR28M);
//# sourceMappingURL=NotificationsDropdownMobile.js.map